import React from 'react';
import { createStyles, LinkProps, withStyles } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

interface FsLinkProps extends LinkProps, Pick<RouterLinkProps, 'to'> {
  bold?: boolean;
}

const FsLink = withStyles(() =>
  createStyles({
    root: {},
  })
)(({ bold, ...otherProps }: FsLinkProps) => (
  <Link
    {...otherProps}
    component={RouterLink}
    style={{ fontWeight: bold ? 600 : undefined }}
  />
));

export default FsLink;
